/* stylelint-disable selector-max-compound-selectors, max-nesting-depth */
sew-ws-search-suggestions {
    @include component-spacing;
    @include grid;

    .headline {
        @include typo-ws-h2;

        margin: 0;
    }

    .items {
        margin-top: 42px;
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
    }
}
